import { render, staticRenderFns } from "./pictureFrame.vue?vue&type=template&id=006723c6&scoped=true&"
import script from "./pictureFrame.vue?vue&type=script&lang=js&"
export * from "./pictureFrame.vue?vue&type=script&lang=js&"
import style0 from "./pictureFrame.vue?vue&type=style&index=0&id=006723c6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006723c6",
  null
  
)

export default component.exports